import { CreateListContractorVehicle, UploadContractorVehicleFormFile } from "../../../reduxToolkit/Files/FilesApi"; // Import API actions for uploading files and creating contractor vehicle records
import { toast } from "react-toastify"; // Import toast for displaying notifications
import routes from "../../../Routes/routes";
import {errorMsg} from "../../../Apis/functions"; // Import application route definitions

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

/**
 * Logic component to handle file upload and creation of contractor vehicle records.
 *
 * @param {function} t - Translation function (from i18next).
 * @param {function} dispatch - Redux dispatch function.
 * @param {function} navigate - Function to navigate to a different route.
 * @param {object} spreadsheetData - Parsed spreadsheet content to validate presence of data.
 * @param {object} data - Data to be submitted for contractor vehicle creation.
 * @param {function} setUpdate - Function to trigger UI update or state refresh.
 * @param {function} getFormData - Function to retrieve form data (e.g., file input).
 * @param {function} isValidFile - Callback executed when file is validated successfully.
 */
export const CreationErrorsContractorVehicleApp = ({
                                                       t,
                                                       dispatch,
                                                       navigate,
                                                       spreadsheetData,
                                                       data,
                                                       setUpdate,
                                                       getFormData,
                                                       isValidFile
                                                   }) => {

    // Handles uploading the contractor vehicle file
    const handleUploadFile = () => {
        setUpdate(true); // Trigger a UI update

        if (spreadsheetData) {
            const formData = getFormData(); // Get form data including the file

            if (formData) {
                dispatch(UploadContractorVehicleFormFile(formData)) // Dispatch upload action
                    .then(({ payload: { data: { data, success } } }) => {
                        if (success === true) {
                            isValidFile(data); // Callback if the file upload is successful
                        }
                    })
                    .catch(() => {
                        // Show error if the upload fails
                        toast.error(t('fail_to_upload_file').toUpperCase());
                    });
            }
        } else {
            // Warn if no file is selected for upload
            toast?.warn(t('there_is_not_file_to_upload').toUpperCase());
        }
    };

    // Handles confirmation and creation of contractor vehicle records
    const handleConfirm = () => {
        dispatch(CreateListContractorVehicle(data)).then(({ payload: { data: { success, code } } }) => {
            if (success === true) {
                toast.success(t('has_been_created_successfully')); // Show success message
                navigate(routes.vehicleContractor.search); // Navigate to vehicle contractor search page
            } else errorMsg(code)
        });
    };

    // Return the handler functions for use in the UI component
    return {
        handleConfirm,
        handleUploadFile
    };
};

// Export the logic component to be used elsewhere in the application
export default CreationErrorsContractorVehicleApp;
